import { foundationMenuItemShadowOptions, MenuItem as FoundationMenuItem, foundationMenuItemTemplate as zeroMenuItemTemplate, defaultMenuItemConfig, } from '@genesislcap/foundation-ui';
import { zeroMenuItemStyles } from './menu-item.styles';
export const zeroMenuItemShadowOptions = foundationMenuItemShadowOptions;
/**
 * @tagname %%prefix%%-menu-item
 */
export class MenuItem extends FoundationMenuItem {
}
/**
 * The Zero Menu Item
 *
 * @public
 * @remarks
 * HTML Element: \<zero-menu-item\>
 */
export const zeroMenuItem = MenuItem.compose(Object.assign({ baseName: 'menu-item', template: zeroMenuItemTemplate, styles: zeroMenuItemStyles, shadowOptions: zeroMenuItemShadowOptions }, defaultMenuItemConfig));
